var o = /* @__PURE__ */ ((l) => (l.ClosedPermanent = "ClosedPermanent", l.ClosedTemporary = "ClosedTemporary", l.Open = "Open", l.Planned = "Planned", l))(o || {}), r = /* @__PURE__ */ ((l) => (l.all = "all", l.blog = "blog", l.event = "events", l.location = "locations", l.news = "news", l.other = "other", l.specialty = "specialties", l.story = "story", l))(r || {});
export {
  o as OperatingStatusCodes,
  r as SiteSearchContentType
};
